import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Props as SelectMultipleProps,
  SelectMultiple,
} from '../../../apps/dashboard/components/Selects/SelectMultiple';

type Props = Omit<SelectMultipleProps, 'values' | 'onChange'> & {
  name: string;
};

export const SelectMultipleControlled: React.FC<
  React.PropsWithChildren<Props>
> = (props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field }) => (
        <SelectMultiple
          {...props}
          values={Array.isArray(field.value) ? field.value : []}
          onChange={field.onChange}
        />
      )}
    />
  );
};
